import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ARTICLE_POSTS } from '../data/ArticlesData';
import Reveal from './ui/Reveal';
import SpotlightCard from './reactbits/SpotlightCard/SpotlightCard';
import ShinyText from './reactbits/ShinyText/ShinyText';

const loadSwiper = async () => {
  const [{ Swiper, SwiperSlide }, { Pagination }] = await Promise.all([
    import('swiper/react'),
    import('swiper/modules'),
  ]);
  return { Swiper, SwiperSlide, Pagination };
};

const ReadMoreArrow = () => (
  <svg width="12" height="12" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1H12M12 1V13M12 1L0.5 12" />
  </svg>
);

export default function Articles() {
  const [{ Swiper, SwiperSlide, Pagination }, setSwiper] = useState({});
  // Lazy-load Swiper JS/CSS only when this slider is rendered
  useEffect(() => {
    const id = 'swiper-css';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = '/assets/css/swiper-bundle.min.css';
      document.head.appendChild(link);
    }
    loadSwiper().then(setSwiper);
  }, []);

  return (
    <div className="home3-blog-area sec-mar">
      <div className="container">
        {/* Section Heading */}
        <Reveal className="row mb-55 wow animate fadeInUp" delay={0.12}>
          <div className="col-lg-12 d-flex justify-content-center">
            <div className="section-title-3 text-center">
              <h2>
                <ShinyText
                  text="Insights, Innovations & Industry Trends"
                  className="nalexus-heading-shine"
                  color="#f1ede3"
                  shineColor="#ffd369"
                  speed={2.8}
                />
              </h2>
                <p>
                  Read practical articles on SaaS engineering, CMS architecture, workflow automation, API-first delivery, security by design, AI integrations, and production-ready GenAI. Each article is written to help teams make better technical decisions and avoid common pitfalls.                </p>
            </div>
          </div>
        </Reveal>

        {/* Swiper Blog Slider */}
        <div className="row">
          <div className="col-12 articles-swiper">
            {Swiper && SwiperSlide && Pagination ? (
            <Swiper
              modules={[Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              pagination={{ clickable: true }}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 3,
                },
              }}
              className="blog-swiper"
            >
              {[...ARTICLE_POSTS].slice(-6).reverse().map(({ id, img, category, date, title }) => (
                <SwiperSlide key={id}>
                  <SpotlightCard className="single-blog magnetic-item nalexus-spotlight" spotlightColor="rgba(223, 169, 37, 0.3)">
                    <div className="blog-img">
                      <img className="img-fluid" src={img} alt="" width={433} height={264} loading="lazy" />
                      <div className="blog-tag">
                        <Link to="/articles">{category}</Link>
                      </div>
                    </div>
                    <div className="blog-content">
                      <ul className="blog-meta">
                        <li><Link to={`/articles/${id}`}>{date}</Link></li>
                      </ul>
                      <h4><Link to={`/articles/${id}`}>{title}</Link></h4>
                      <div className="blog-footer">
                        <div className="read-btn">
                          <Link to={`/articles/${id}`}>Explore Article <ReadMoreArrow /></Link>
                        </div>
                        <div className="social-area">
                          <ul>
                            <li><a href="https://www.linkedin.com/company/nalexus-technologies/" aria-label="Visit Nalexus Technologies on LinkedIn"><i className="bx bxl-linkedin"></i></a></li>
                            <li><a href="https://www.instagram.com/nalexus_technologies/" aria-label="Visit Nalexus Technologies on Instagram"><i className="bx bxl-instagram"></i></a></li>
                          </ul>
                          <span><img src="/assets/img/content/plain-icon.svg" alt="" /></span>
                        </div>
                      </div>
                    </div>
                  </SpotlightCard>
                </SwiperSlide>
              ))}
            </Swiper>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}






